<template>
    <div class="main-orderitem">
        <div class="item-header">
            <!-- hard code check type -->
            <div class="item-type">รับที่สาขา</div>
            <div class="item-date">รับเมื่อ {{ timeForm }}</div>
        </div>
        <div class="brown-line"></div>
        <div class="item-body">
            <ul class="item-list">
                <li
                    class="item-coffee"
                    v-for="(item, index) in coffeeList"
                    :key="index"
                >
                    <div class="image-container">
                        <img :src="item.FullImageUrl" alt="" />
                    </div>
                    <div class="desc-container">
                        <div class="desc-name">
                            {{ item.Name }}
                        </div>
                        <div class="desc-amount">
                            {{ item.TotalQuanity }} ชิ้น
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="brown-line"></div>
        <div v-if="expire" class="expire-text">หมดอายุ</div>
        <div v-else @click="clickOrder()" class="item-btn">
            <span>รายละเอียด</span>
            <img src="@/assets/campaignlist/white_forward_new.svg" alt="" />
        </div>
    </div>
</template>

<script>
import moment from "moment";
import Locale from "@/helper/locale/locale.js";
import ConfigManager from "@/config/ConfigManager.js";

export default {
    name: "OrderItem",
    components: {},
    props: {
        order: Object,
    },
    data() {
        return {
            coffeeList: {},
            timeForm: "",
            lblDate: Locale.getLbl().date,

            //cancel order function
            expire: false,
            cancelable: true,
        };
    },
    mounted() {
        this.initData();
    },
    watch: {
        order() {
            return this.initData();
        },
    },
    methods: {
        initData() {
            this.coffeeList = this.order.OrderDetail[0].Item;

            for (let i = 0; i <= this.coffeeList.length - 1; i++) {
                for (
                    let j = 0;
                    j <= Object.keys(this.order.CampaignDictionary).length - 1;
                    j++
                ) {
                    if (
                        this.coffeeList[i].CampaignId ==
                        Object.keys(this.order.CampaignDictionary)[j]
                    ) {
                        this.coffeeList[i][
                            "FullImageUrl"
                        ] = `${ConfigManager.getBlobUrl()}/nestle/nescafe_streetcafe/Images/menu_drink/${
                            this.coffeeList[i].CampaignId
                        }.png`;
                        this.coffeeList[i]["Name"] =
                            this.order.CampaignDictionary[
                                Object.keys(this.order.CampaignDictionary)[j]
                            ].Name;
                    }
                }
            }

            let hashTable = {};
            for (let i = 0; i <= this.coffeeList.length - 1; i++) {
                hashTable[this.coffeeList[i].CampaignId] =
                    hashTable[this.coffeeList[i].CampaignId] +
                        this.coffeeList[i].Quantity ||
                    this.coffeeList[i].Quantity;
            }
            for (let i = 0; i <= Object.keys(hashTable).length; i++) {
                this.coffeeList.map((item) => {
                    if (item.CampaignId == Object.keys(hashTable)[i]) {
                        // item.Quantity = hashTable[item.CampaignId];
                        item["TotalQuanity"] = hashTable[item.CampaignId];
                    }
                });
            }

            let uniqueArray = this.coffeeList.filter(
                (item, index, self) =>
                    self.findIndex(
                        (value) => value.CampaignId === item.CampaignId
                    ) === index
            );

            this.coffeeList = uniqueArray;

            let timeStamp = parseInt(this.order.DeliveryTime + "000");

            let time = moment(timeStamp).format("lll");
            let now = Date.now();
            // api ส่งเวลา time zone +00 มา
            let timeGMT = moment(timeStamp)
                .utcOffset("GMT+00:00")
                .format("HH:mm");
            let newtime = time.split(" ");
            let year = parseInt(newtime[2]) + 543;
            let month =
                this.lblDate.month_short[moment(timeStamp).format("M") - 1];
            this.timeForm =
                newtime[1].replace(/\D/g, "") +
                " " +
                month +
                " " +
                year +
                " - " +
                timeGMT;
            // api ส่งเวลา time zone +00 มา เลยต้อง + เพิ่ม 7
            if (now > timeStamp - 28800000) {
                this.cancelable = false;
            }
        },
        clickOrder() {
            let newOrder = {
                ...this.order,
                dateForm: this.timeForm,
                cancelable: this.cancelable,
            };
            console.log(newOrder);
            this.$emit("clickOrder", newOrder);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/style/_mixin.scss";
ul {
    margin: 0;
    padding: 0;
}
li {
    margin: 0;
}
.main-orderitem {
    background-color: $color-light-grey-300;
    color: $color-text;
    border-radius: 10px;
    margin: 15px 18px;
    padding: 10px 0;
    .item-header {
        display: flex;
        font-size: 14px;
        align-items: center;
        padding-bottom: 10px;
        justify-content: space-between;
        .item-type {
            color: #fff;
            background-color: $color-brown-700;
            font-family: "PromptSemiBold";
            padding: 2px 12px;
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
        }
        .item-date {
            width: 70%;
            text-align: right;
            margin-right: 12px;
        }
    }
    .brown-line {
        background-color: #cac3b7;
        height: 1px;
        margin: 0;
    }
    .item-body {
        margin: 0;
        background-color: $color-light-grey-200;
        .item-list {
            .item-coffee {
                display: flex;
                padding: 10px;
                .image-container {
                    border: 1px solid $color-brown-700;
                    border-radius: 10px;
                    padding: 2px;
                    background-color: $color-brown-700;
                    img {
                        height: 3.5rem;
                    }
                }
                .desc-container {
                    margin-left: 10px;
                    font-size: 16px;
                    .desc-name {
                        font-family: "PromptSemiBold";
                    }
                }
            }
        }
    }
    .item-btn {
        display: flex;
        justify-content: center;
        margin: 10px auto 0px;
        width: 40%;
        padding: 5px 16.5px;
        border-radius: 20px;
        color: #fff;
        background-color: $color-text;
        font-size: 16px;
        img {
            margin-left: 8px;
        }
    }
    .expire-text {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 5px;
        color: #d50513;
        text-decoration: underline;
    }
}
</style>
